export default function (offers) {
  var items = [];
  for (var i = 0; i < offers.length; i += 1) {
    var offer = offers[i];
    offer.data = {};
    offer.data.seriesString = offer.multivehicle ? 'multi' : offer.model.code;
    offer.data.trimCodeString = offer.model.applicableTrims[0] ? offer.model.applicableTrims[0].code : '0';
    offer.data.durationString = 'none'; // used for data-duration
    offer.data.dueAtSigningString = 'none';// data-due-at-signing
    offer.data.cashBackString = 'none';// data-cash-back
    offer.data.monthlyPaymentString = 'none';// data-monthly-payment
    offer.data.allowableMileageString = 'none';// data-mileage
    offer.data.creditRatingString = 'none'; // data-credit-rating
    offer.data.dataRateDLString = 'none'; // data-rate-dl
    offer.data.SubTypeForMisc = 'none';// data-subtype-for-misc

    if (offer.offerType === 'apr') {
      offer.data.durationString = offer.apr.duration;
      offer.data.cashBackString = offer.extraCashAmount === null ? 'none' : offer.extraCashAmount;
      offer.data.creditRatingString = offer.apr.creditRating;
      offer.data.dataRateDLString = offer.apr.rate;
      // console.log(i,'A cashBackString :', offer.cashBackString , offer);
    }
    if (offer.offerType === 'lease') {
      offer.data.durationString = offer.lease.duration;
      offer.data.dueAtSigningString = offer.lease.dueAtSigningAmount;
      offer.data.cashBackString = offer.extraCashAmount === null ? 'none' : offer.extraCashAmount;
      offer.data.monthlyPaymentString = offer.lease.monthlyPayment;
      offer.data.allowableMileageString = offer.lease.allowableMileage;
      offer.data.creditRatingString = offer.lease.creditRating;
      offer.data.dataRateDLString = offer.lease.rate;
    }
    if (offer.offerType === 'cash') {
      var isMulti = !!offer.multivehicle;
      if (isMulti) {
        offer.data.cashBackString = offer.multivehicle.amount;
      } else {
        offer.data.cashBackString = offer.cash.amount;
      }
    }
    if (offer.offerType === 'misc') {
      offer.data.SubTypeForMisc = offer.miscellaneous.label;
    }

    offer.displayDisclaimersOrRestrictions = (offer.disclaimers.disclaimer.length > 0  || offer.restrictions.restriction.length > 0 || offer.additionalDisclaimers.length > 0 || offer.additionalRestrictions.length > 0);

    items.push(offer);
  }
  return items;
}
